import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";
import { WawiConnectorExecutable, WawiConnectorType, WawiConnectorTypeExecutable } from "../wawi-connector.types";

export class WawitogoWebConnectorService implements WawiConnectorExecutable{

    public executable: true = true;
    public type: WawiConnectorTypeExecutable = WawiConnectorType.WAWITOGO_WEB;

    constructor(
        private baseUrl: string
    ) {}

    public executeCommand(url: string): Promise<HttpFunctionResult> {
        window.open(`${this.baseUrl}/${url}`, "_blank")
        return Promise.resolve({ success: true });
    }
    public openArticle(articleId: number): Promise<HttpFunctionResult> {
        return this.executeCommand(`app/article/id/${articleId}`)
    }
    public openCustomer(customerId: number): Promise<HttpFunctionResult> {
        return this.executeCommand(`app/address/id/${customerId}`)
    }
    public openProcess(processId: number): Promise<HttpFunctionResult> {
        return this.executeCommand(`app/order/id/${processId}`)
    }
    
}